import { render, staticRenderFns } from "./personal-settings.component.vue?vue&type=template&id=06b5b178&"
import script from "./personal-settings.component.vue?vue&type=script&lang=ts&"
export * from "./personal-settings.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports